import { render, staticRenderFns } from "./adver-list.vue?vue&type=template&id=8e708a34&scoped=true"
import script from "./adver-list.vue?vue&type=script&lang=js"
export * from "./adver-list.vue?vue&type=script&lang=js"
import style0 from "./adver-list.vue?vue&type=style&index=0&id=8e708a34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e708a34",
  null
  
)

export default component.exports